var $ = require('jquery');

$(function () {
    // mobile accordion
    $('.featured-services__tab-content__name').eq(0).addClass('selected');

    $('.featured-services__tab-content__group').on('click', function (e) {
        e.preventDefault();
        $(this).siblings('.featured-services__tab-content__group')
            .children('.featured-services__tab-content__name').removeClass('selected')
            .next('.featured-services__tab-content__item').slideUp();
        $(this).children('.featured-services__tab-content__name').toggleClass('selected')
            .next('.featured-services__tab-content__item').slideToggle();
    });

    // desktop tabs
    $('.featured-services__tabs__tab').eq(0).addClass('selected');
    $('.featured-services__tab-content__item').eq(0).addClass('selected');

    $('.featured-services__tabs__tab a').click(function (e) {
        var dataId = $(this).attr('data-service-id');

        e.preventDefault();
        $(this).parent().addClass('selected').siblings().removeClass('selected');
        $('.featured-services__tab-content__item[data-service-id="' + dataId + '"]').addClass('selected').parent().siblings().children().removeClass('selected');
    });

    $('.featured-services__tab-content__item').on('click', function (e) {
        e.stopPropagation();
    });
});
